import type {
  RefundAccountCheckRequest,
  RefundAccountRequestV2,
  RefundDataSource,
  ValidateAccountHolderRequest,
} from '~/api/data-source/refund';
import { refundDataSource } from '~/api/data-source/refund';
import type { Bank, RefundAccount, RefundAccountCheck } from '~/api/model';
import {
  bankSchema,
  parseModel,
  parseModelArray,
  refundAccountCheckSchema,
  refundAccountSchema,
} from '~/api/model';

export interface RefundRepository {
  // Query
  getRefundAccount(): Promise<RefundAccount>;
  getRefundBankList(): Promise<Bank[]>;

  // Mutation
  updateRefundAccount(data: RefundAccountRequestV2): Promise<RefundAccount>;
  validateAccountHolder(
    data: ValidateAccountHolderRequest,
  ): Promise<RefundAccount>;
  checkRefundAccount(
    data: RefundAccountCheckRequest,
  ): Promise<RefundAccountCheck>;
}

export class RefundRepositoryImpl implements RefundRepository {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    private readonly dataSource: RefundDataSource = refundDataSource,
  ) {}

  async getRefundAccount() {
    const response = await this.dataSource.getRefundAccount();
    return parseModel(refundAccountSchema, response, 'RefundAccount');
  }

  async getRefundBankList() {
    const response = await this.dataSource.getRefundBankList();
    return parseModelArray(bankSchema, response, 'Bank');
  }

  async updateRefundAccount(data: RefundAccountRequestV2) {
    const response = await this.dataSource.updateRefundAccount(data);
    return parseModel(refundAccountSchema, response, 'RefundAccount');
  }

  async validateAccountHolder(data: ValidateAccountHolderRequest) {
    const response = await this.dataSource.validateAccountHolder(data);
    return parseModel(refundAccountSchema, response, 'RefundAccount');
  }

  async checkRefundAccount(data: RefundAccountCheckRequest) {
    const response = await this.dataSource.checkRefundAccount(data);
    return parseModel(refundAccountCheckSchema, response, 'RefundAccountCheck');
  }
}

export const refundRepository = new RefundRepositoryImpl();
